export { Loading } from "./Loading";
export type { ISVGProps } from "./Loading";
